module.exports = function (id, cookieExpiration) {
    var cookieName = id + "_Viewed";
    
    function setCookie(name, value, expiration) {

        if (!ICF.Utils.Consent.HasAcceptedFunctional()) {            
            return;
        }

        var date;

        if (expiration != '') {
            date = new Date();
            date.setTime(date.getTime() + (expiration * 24 * 60 * 60 * 1000));
        }
        else {
            date = new Date(2147483647 * 1000);
        }

        var expires = "; expires=" + date.toUTCString();
        var cookieValue = name + "=" + (value || "") + expires + "; path=/";

        document.cookie = cookieValue;
    }

    setCookie(cookieName, true, cookieExpiration);
};